import * as fromDatatype from '../datatype-library/index';

export interface bl_ocr_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ocr_generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  ocr_scanned_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  ocr_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ocr_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  ocr_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  ocr_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ocr_scanned_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
}

export class bl_ocr_generic_doc_line_RowClass implements bl_ocr_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  ocr_generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  ocr_scanned_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  ocr_scanned_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  ocr_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  ocr_item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  ocr_item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  ocr_item_hdr_desc: fromDatatype.VarcharDatatypeInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ocr_scanned_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
}
